export default {
    CREATE_TEMPLATE: () => '/template/createTemplate',
    GET_ALL_TEMPLATE: () => '/template/getAllTemplate',
    DELETE_TEMPLATE: (id) => `/template/deleteTemplate/${id}`,
    UPDATE_TEMPLATE: (id) => `/template/updateTemplate/${id}`,
    GET_TEMPLATE_ID: (id) => `/template/getTemplateBy/${id}`,
};
